export default __webpack_public_path__ + "static/media/PIL.91aafd6a.pdf";